import React, { useEffect, useState } from 'react';
import useApp from 'hooks/useApp'
import styles from './index.module.css'

const SchoolDetail2 = () => {

	const App = useApp()
	const [menuOpen, setMenuOpen] = useState(0)

	useEffect(() => {
		App.setHeader({
			show: true,
			title: "유치원 상세",
			left: "",
			right: <i className="icon icon_close" />
		})

		App.setShowNav(false)
		App.setMainClass("white")
	}, [])

	return (
		<div className="page">
			<div className="shadow">
				<div className="padding">
					{/* 지도 영역 */}
					<div style={{ height: "20rem", background: "#f5f5f5" }}></div>
					<div className={`${styles["school-list"]} flex-justify_between mt_40`}>
						<div>
							<i className="tag tag-box tag-gray">사립(법인)</i>
							<p className="mt_5">(재)천주교수원교구유지재단데레사유치원</p>
							<div className={`${styles["tag-area"]} mt_10`}>
								<span>#아이돌봄</span>
								<span>#기본운영</span>
							</div>
						</div>
						<div className={styles["call-btn"]}>
							<i className="icon icon_call" />
						</div>
					</div>
				</div>
			</div>
			<div className="padding">
				<ul className={`${styles["school-detail"]} accordion-list`}>
					<li onClick={() => setMenuOpen(0)} className={menuOpen === 0 ? "active" : ""}>
						<div className={`${styles["list-title"]}`}>
							<p>기본정보</p>
							<i className="icon icon_arrow_sm bottom" />
						</div>
						<div className="menu-open">
							<div className={styles.box}>
								<ul className={styles["user-info"]}>
									<li>
										<div className="flex-align_start">
											<i className="icon_life icon_life_calendar icon mr_5" />
											<span>개원일 : 2000.09.14</span>
										</div>
									</li>
									<li>
										<div className="flex-align_start">
											<i className="icon_life icon_life_user icon mr_5" />
											<span>원장 : 김모니</span>
										</div>
									</li>
									<li>
										<div className="flex-align_start">
											<i className="icon_life icon_life_bus icon mr_5" />
											<span>통학 차량 1대 운영</span>
										</div>
									</li>
									<li>
										<div className="flex-align_start">
											<i className="icon_life icon_life_time icon mr_5" />
											<span>07시 30분 ~ 19시 30분 운영</span>
										</div>
									</li>
									<li>
										<div className="flex-align_start">
											<i className="icon_life icon_life_office icon mr_5" />
											<span>강남서초교육지원청</span>
										</div>
									</li>
									<li>
										<div className="flex-align_start">
											<i className="icon_life icon_life_mail icon mr_5" />
											<span>www.naver.com</span>
										</div>
									</li>
									<li>
										<div className="flex-align_start">
											<i className="icon_life icon_life_call icon mr_5" />
											<span>032-1231-2341</span>
										</div>
									</li>
									<li>
										<div className="flex-align_start">
											<i className="icon_life icon_life_place icon mr_5" />
											<span>인천광역시 서구 이음3로 130 관리동<i className="icon icon_copy ml_5" /></span>
										</div>
									</li>
								</ul>
							</div>
						</div>
					</li>
					<li onClick={() => setMenuOpen(1)} className={menuOpen === 1 ? "active" : ""}>
						<div className={`${styles["list-title"]}`}>
							<p>유아</p>
							<i className="icon icon_arrow_sm bottom" />
						</div>
						<div className="menu-open">
							<div className={styles.box}>
								<div>연령별 유아(학급 수)</div>
								<div className={`${styles["list-item"]} mt_20`}>
									<div>
										<span>유아 수</span>
										<span>48명</span>
									</div>
									<div>
										<span>학급 수</span>
										<span>7학급</span>
									</div>
								</div>
								<hr className="my_30" />
								<div>연령별 육아(학급 수)</div>

								{/* 40% 미만일때 over-txt 클래스 추가 */}
								<ul className={`${styles["count-bar"]} mt_20`}>
									<li>
										<span>만 3세</span>
										<div className={styles.bar}>
											<span style={{ width: "80%" }}>
												<span>15명(2학급)</span>
											</span>
										</div>
									</li>
									<li>
										<span>만 4세</span>
										<div className={styles.bar}>
											<span style={{ width: "60%" }}>
												<span>10명(2학급)</span>
											</span>
										</div>
									</li>
									<li>
										<span>만 5세</span>
										<div className={styles.bar}>
											<span style={{ width: "45%" }}>
												<span>7명(1학급)</span>
											</span>
										</div>
									</li>
									<li>
										<span>유아혼합</span>
										<div className={styles.bar}>
											<span style={{ width: "30%" }}>
												<span className={styles["over-txt"]}>5명(2학급)</span>
											</span>
										</div>
									</li>
									<li>
										<span>특수유아</span>
										<div className={styles.bar}>
											<span style={{ width: 0 }}>
												<span className={styles["over-txt"]}>0명(-)</span>
											</span>
										</div>
									</li>
								</ul>
							</div>
						</div>
					</li>
					<li onClick={() => setMenuOpen(2)} className={menuOpen === 2 ? "active" : ""}>
						<div className={`${styles["list-title"]}`}>
							<p>교직원</p>
							<i className="icon icon_arrow_sm bottom" />
						</div>
						<div className="menu-open">
							<div className={styles.box}>
								<div>현황</div>
								<div className="flex-align_center mt_20">
									{/* 그래프 영역 */}
									<div style={{ width: "13rem", height: "13rem", background: "#eee" }} />
									<ul className={`${styles["info-item"]} flex--item_1 ml_20`}>
										<li>
											<div className="color-title">
												<p className="light-blue">원장/원감</p>
											</div>
											<span>1명</span>
										</li>
										<li>
											<div className="color-title">
												<p className="green">일반교사</p>
											</div>
											<span>7명</span>
										</li>
										<li>
											<div className="color-title">
												<p className="yellow">영양교사</p>
											</div>
											<span>1명</span>
										</li>
									</ul>
								</div>
							</div>
						</div>
					</li>
					<li onClick={() => setMenuOpen(3)} className={menuOpen === 3 ? "active" : ""}>
						<div className={`${styles["list-title"]}`}>
							<p>시설</p>
							<i className="icon icon_arrow_sm bottom" />
						</div>
						<div className="menu-open">
							<div className={styles.box}>
								<div>면적</div>
								<div className={`${styles["list-item"]} mt_20`}>
									<div>
										<span>교실</span>
										<span>188㎡(5개)</span>
									</div>
									<div>
										<span>체육장</span>
										<span>188㎡</span>
									</div>
									<div>
										<span>보건/위생 공간</span>
										<span>188㎡</span>
									</div>
									<div>
										<span>조리/급식 공간</span>
										<span>188㎡</span>
									</div>
									<div>
										<span>기타 공간</span>
										<span>188㎡</span>
									</div>
								</div>
								<hr className="my_30" />
								<div>안전 및 환경</div>
								<div className={`${styles["list-item"]} mt_20`}>
									<div>
										<span>CCTV설치</span>
										<span>건물 안 5대, 건물 밖 1대</span>
									</div>
									<div>
										<span>소방대피훈련일</span>
										<span>2021.04.04</span>
									</div>
									<div>
										<span>소방안전점검일</span>
										<span>2021.04.04</span>
									</div>
									<div>
										<span>가스점검일</span>
										<span>2021.04.04</span>
									</div>
									<div>
										<span>전기설비점검일</span>
										<span>2021.04.04</span>
									</div>
									<div>
										<span>놀이시설안전점검일</span>
										<span>2021.04.04</span>
									</div>
								</div>
							</div>
						</div>
					</li>
				</ul>

				<div className={`${styles["guide-bottom"]} mt_40`}>유치원 정보공개포털에서 받아오는 정보입니다.</div>
			</div>
		</div>
	)
}

export default SchoolDetail2